import { render, staticRenderFns } from "./StockHistoryYear.vue?vue&type=template&id=32c75dc4&"
import script from "./StockHistoryYear.vue?vue&type=script&lang=js&"
export * from "./StockHistoryYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports